'use client';

import React, { type ReactNode } from 'react';
import styles from './styles.module.css';

interface FaqWrapperItemProps {
  title: string;
  slug?: string;
  id: string;
  children: ReactNode;
}

export const FaqWrapperItem = ({
  title,
  id,
  children,
}: FaqWrapperItemProps) => {
  return (
    <div className={styles.faqWrapper} id={id}>
      <h4 className={styles.faqTitle}>{title}</h4>
      <div className={styles.faqContent}>{children}</div>
    </div>
  );
};

export default FaqWrapperItem;
